<template>
    <div class="w-100">
        <question :text="$t(item.text, { currency: locale.currency, OT_investAmount: investmentAmount && formatNumber(investmentAmount, locale.tag) })" />

        <div
            v-if="getInvestmentScenarios()"
            class="investment-scenario__wrapper d-flex flex-wrap"
        >
            
            <div class="investment-scenario__button-container d-flex justify-content-around">
                <div
                    v-for="(investment, i) in getInvestmentScenarios().slice(0,2)" 
                    :key="i"
                    class="investment-scenario__button"
                >
                    <vertical-button
                        :header="`Investment ${investment.name}`"
                        :variant="investment.variant"
                        :choice="i"
                        :selected="result === i"
                        :shadowed="result !== null && result !== i"
                        @select="handleChange"
                    >
                        <template v-slot:option-a>
                            <outcome
                                :difference="`${locale.currency} ${formatNumber(investment.gain, locale.tag)}`"
                                :resize="result"
                                direction="up"
                            />
                        </template>
                        <template v-slot:option-b>
                            <outcome
                                :difference="`${locale.currency} ${formatNumber(investment.loss * -1, locale.tag)}`"
                                :resize="result"
                                direction="down"
                            />
                        </template>
                    </vertical-button>
                </div>
            </div>

            <!-- we have to split the scenarios for proper positioning -->
            <div class="investment-scenario__button-container d-flex justify-content-around">
                <div
                    v-for="(investment, i) in getInvestmentScenarios().slice(2,4)" 
                    :key="i + 2"
                    class="investment-scenario__button"
                >
                    <vertical-button
                        :header="`Investment ${investment.name}`"
                        :variant="investment.variant"
                        :choice="i + 2"
                        :selected="result === i + 2"
                        :shadowed="result !== null && result !== i + 2"
                        @select="handleChange"
                    >
                        <template v-slot:option-a>
                            <outcome
                                :difference="`${locale.currency} ${formatNumber(investment.gain, locale.tag)}`"
                                :resize="result"
                                direction="up"
                            />
                        </template>
                        <template v-slot:option-b>
                            <outcome
                                :difference="`${locale.currency} ${formatNumber(investment.loss * -1, locale.tag)}`"
                                :resize="result"
                                direction="down"
                            />
                        </template>
                    </vertical-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import colorVariantMixin from '@/components/mixins/colorVariantMixin'
import question from '@/components/ui/question'
import outcome from '@/components/ui/outcome'
import verticalButton from '@/components/inputs/verticalButton'

import { formatNumber } from '@/utils/numbers'

export default {
    name: 'gainsLossesItem',
    components: {
        question,
        outcome,
        verticalButton,
    },
    mixins: [colorVariantMixin],
    props: {
        item: {
            type: Object,
        },
        metaData: {
            type: Object
        },
        locale: {
            type: Object
        }
    },
    data() {
        return {
            formatNumber,
            result: null,
        }
    },
    computed: {
        investmentAmount() {
            return this.metaData && this.metaData.metaInformation && parseInt(this.metaData.metaInformation.INVESTMENT_AMOUNT)
        },
    },
    methods: {
        getInvestmentScenarios() {
            if(this.investmentAmount) {
                const amounts = type => {
                        const sign = type === 'LOSSES' ? -1 : 1
                        return this.item.labels
                            .filter(label => label.subtype.includes(type))
                            .map(label => label.key)
                            .sort()
                            .map(key => this.$t(key))
                            .map(value => (parseFloat(value) / 100) * this.investmentAmount * sign);
                    }

                const gains = amounts('GAINS')
                const losses = amounts('LOSSES')
                const investmentNames = ['A', 'B', 'C', 'D']
                const colorVariants = ['bq-burgundy', 'bq-blue', 'bq-turquoise', 'bq-orange'];

                const investmentScenarios = gains.map((val, i) => ({ 
                    name: investmentNames[i],
                    result: i,
                    gain: Math.floor(val),
                    loss: Math.floor(losses[i]),
                    variant: colorVariants[i],
                }))

                return investmentScenarios
            }
        },
        handleChange(result) {
            this.result = result
            this.$emit('answer', { result: this.result })
        },
    },
    mounted() {
        this.getInvestmentScenarios()
    }
}
</script>
<style lang="scss">
    .investment-scenario__button-container {
        min-width: 50%;
        @media screen and (max-width: 992px) {
            min-width: 66%;
        }
        @media screen and (max-width: 768px) {
            min-width: 100%;
        }
        margin: 0 auto 1em auto;
        height: 160px;

        @media screen and (max-width: 450px) {
            font-size: 0.875rem;
        }
    }

    .gains-losses-item__investment-radio > input {
        display: none;
    }

    .investment-scenario__button {
        width: 160px;
        margin: 0 0.5em 1em 0.5em;
    }

</style>